import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a8720e60"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "combined-td-product"
};
const _hoisted_2 = {
  class: "curved-line"
};
const _hoisted_3 = {
  class: "curved",
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "16",
  viewBox: "0 0 23 16",
  fill: "none"
};
const _hoisted_4 = ["stroke"];
const _hoisted_5 = ["height", "viewBox"];
const _hoisted_6 = ["stroke"];
const _hoisted_7 = {
  key: 1,
  class: "dot"
};
const _hoisted_8 = ["height", "viewBox"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0.333333 3C0.333333 4.47276 1.52724 5.66667 3 5.66667C4.47276 5.66667 5.66667 4.47276 5.66667 3C5.66667 1.52724 4.47276 0.333333 3 0.333333C1.52724 0.333333 0.333333 1.52724 0.333333 3ZM3 3H2.5V15H3H3.5V3H3Z",
  fill: "#E3E3E3"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = ["id"];
const _hoisted_12 = {
  class: "custom-img-wrapper"
};
const _hoisted_13 = {
  class: "combined-product-box"
};
const _hoisted_14 = {
  class: "product-asin-sku-all"
};
const _hoisted_15 = {
  class: "product-asin-sku"
};
const _hoisted_16 = {
  class: "product-asin-sku-only is-hovering"
};
const _hoisted_17 = {
  class: "content-box"
};
const _hoisted_18 = {
  class: "text-content"
};
const _hoisted_19 = {
  key: 0,
  class: "product-title-text-style"
};
const _hoisted_20 = {
  class: "status-item"
};
const _hoisted_21 = {
  class: "product-asin-sku-only"
};
const _hoisted_22 = {
  class: "country-asin-flexbox"
};
const _hoisted_23 = {
  class: "product-sku-asin-text"
};
const _hoisted_24 = {
  key: 0,
  style: {
    "position": "relative"
  },
  class: "ellipsis-2"
};
const _hoisted_25 = {
  key: 1,
  class: "sku-not-found"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1));
const _hoisted_27 = {
  style: {
    "position": "relative"
  },
  class: "ellipsis-2"
};
const _hoisted_28 = {
  key: 0,
  class: "inactive-tag"
};
const _hoisted_29 = {
  class: "variation-theme-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_img = _resolveComponent("b-img");
  const _component_product_with_flag_overlay = _resolveComponent("product-with-flag-overlay");
  const _component_WrapWithCopy = _resolveComponent("WrapWithCopy");
  const _component_seo_parent_variation_theme = _resolveComponent("seo-parent-variation-theme");
  const _component_wrap_with_status_icon = _resolveComponent("wrap-with-status-icon");
  const _component_app_td = _resolveComponent("app-td");
  return _openBlock(), _createBlock(_component_app_td, {
    align: "center",
    id: "name-column",
    class: _normalizeClass(["border-table-row seo-child-product-cell", [{
      'is-filtered-child': $props.isFiltering
    }]]),
    stickyColumn: "true",
    style: _normalizeStyle({
      left: $props.pushModal ? '21.5px' : '0px'
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_wrap_with_status_icon, {
      validationStatus: $props.item.product_name_style.validationStatus,
      hugStyles: {
        padding: '12px 16px 12px 4px',
        width: '368px'
      },
      status: $props.item.product_name_style.status,
      isHovering: $data.isHovering,
      isCopying: _ctx.isCopying,
      onMouseover: $options.onMouseOver,
      onMouseleave: $options.onMouseLeave,
      class: _normalizeClass([{
        notHoverable: $data.cellNotHoverable
      }, {
        last: $props.last
      }]),
      id: $props.uid,
      onClick: _cache[6] || (_cache[6] = () => {
        if (!$data.cellNotHoverable) {
          _ctx.$emit('onEdit', {
            item: $props.item,
            type: 'product_name',
            title: 'Title'
          });
        }
      })
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createElementBlock("svg", _hoisted_3, [_createElementVNode("path", {
        d: "M1 0V7C1 11.4183 4.58172 15 9 15H23",
        stroke: $props.isFiltering ? '#E3E3E3' : '#A666FF'
      }, null, 8, _hoisted_4)])), !$props.isFiltering || $props.index !== 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "line",
        style: _normalizeStyle(`top: ${$props.isFiltering ? '-97px' : '-60px'}`)
      }, [(_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1",
        height: $props.isFiltering ? '97' : $props.toggleLineHeight,
        viewBox: `0 0 1 ${$props.isFiltering ? '97' : $props.toggleLineHeight}`,
        fill: "none"
      }, [_createElementVNode("path", {
        d: "M0.999973 -9.61652e-07L0.999941 743C0.999941 747.418 4.58166 751 8.99994 751L23 751",
        stroke: $props.isFiltering ? '#E3E3E3' : '#A666FF'
      }, null, 8, _hoisted_6)], 8, _hoisted_5))], 4)) : (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "6",
        height: $props.toggleLineHeight,
        viewBox: `0 0 6 ${$props.toggleLineHeight}`,
        fill: "none"
      }, _hoisted_10, 8, _hoisted_8)), _createElementVNode("div", {
        id: `${$props.uid}-parent-link`,
        class: "parent-link-btn",
        onMouseover: _cache[0] || (_cache[0] = (...args) => $options.parentLinkHover && $options.parentLinkHover(...args)),
        onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.parentLinkLeave && $options.parentLinkLeave(...args)),
        onClick: _cache[2] || (_cache[2] = e => $options.onParentLinkBtnClicked(e))
      }, [_createElementVNode("div", null, [_createVNode(_component_AppIcon, {
        icon: "parent-link",
        color: $data.parentLinkColor
      }, null, 8, ["color"])]), _createVNode(_component_app_popover, {
        target: `${$props.uid}-parent-link`,
        placement: "top"
      }, {
        default: _withCtx(() => [_createTextVNode("Add all variants of this product to selection ")]),
        _: 1
      }, 8, ["target"])], 40, _hoisted_11)]))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "image-with-overlay",
        onMouseover: _cache[4] || (_cache[4] = (...args) => $options.preventCellHover && $options.preventCellHover(...args)),
        onMouseleave: _cache[5] || (_cache[5] = (...args) => $options.allowCellHover && $options.allowCellHover(...args))
      }, [_createVNode(_component_app_icon, {
        onClick: _cache[3] || (_cache[3] = $event => $options.onImageChange($props.item)),
        class: "navigation-btn",
        icon: "navigation-button",
        size: "16"
      }), _createVNode(_component_product_with_flag_overlay, {
        flag: $props.item.flag,
        country: $props.item.country
      }, {
        default: _withCtx(() => [_createVNode(_component_b_img, {
          src: $props.item?.image_small || '/assets/images/amazon-logo-transparent.svg',
          alt: "Image",
          class: "custom-img",
          style: _normalizeStyle({
            width: $data.imgWidth,
            height: $data.imgHeight
          })
        }, null, 8, ["src", "style"])]),
        _: 1
      }, 8, ["flag", "country"])], 32)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("p", {
        class: "ellipsis ellipsis-2 title",
        style: _normalizeStyle($props.item.product_name_style.style)
      }, [$props.item.product_name !== null && typeof $props.item.product_name !== 'undefined' && $props.item.product_name.trim() != '' ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($props.item.product_name), 1)) : _createCommentVNode("", true)], 4), $props.item.product_name_style.status != 'unknown' && $data.tooltipOn ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 0,
        target: $props.uid,
        "auto-width": "",
        placement: "top",
        "custom-class": `${$props.item.product_name_style.status} ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createElementVNode("span", null, _toDisplayString($props.item.product_name_style.tooltipText), 1)])]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true), !$props.item.sku && $data.tooltipOn ? (_openBlock(), _createBlock(_component_app_popover, {
        key: 1,
        target: $props.uid,
        "auto-width": "",
        placement: "top",
        "custom-class": `not-editable ${!$props.showPopover ? 'hide-popover' : ''}`
      }, {
        default: _withCtx(() => [_createTextVNode(" Assign SKU to the item to start editing the content ")]),
        _: 1
      }, 8, ["target", "custom-class"])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [$props.item.sku ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_WrapWithCopy, {
        onMouseover: $options.preventCellHover,
        onMouseleave: $options.allowCellHover
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.item.sku), 1)]),
        _: 1
      }, 8, ["onMouseover", "onMouseleave"])])) : (_openBlock(), _createElementBlock("div", _hoisted_25, "SKU not found")), _hoisted_26, _createElementVNode("div", _hoisted_27, [_createVNode(_component_WrapWithCopy, {
        onMouseover: $options.preventCellHover,
        onMouseleave: $options.allowCellHover
      }, {
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.item.asin), 1)]),
        _: 1
      }, 8, ["onMouseover", "onMouseleave"])])])])])]), $props.item.listing_status === 'Inactive' ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Inactive ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.variation_values, theme => {
        return _openBlock(), _createBlock(_component_seo_parent_variation_theme, {
          theme: theme,
          showIcon: false
        }, null, 8, ["theme"]);
      }), 256))])])])]),
      _: 1
    }, 8, ["validationStatus", "status", "isHovering", "isCopying", "onMouseover", "onMouseleave", "class", "id"])]),
    _: 1
  }, 8, ["class", "style"]);
}